;(function () {
  'use strict'

  angular
    .module('contrast.library.policy')
    .factory('LibraryPolicyService', LibraryPolicyService)

  function LibraryPolicyService(
    $q,
    logger,
    LibraryFactory,
    preferencesService,
    ErrorService,
    PREFERENCE_PROPERTIES
  ) {
    'ngInject'

    var service = {
      getInitData: getInitData,
      update: update
    }

    return service

    function getInitData() {
      return $q
        .all({
          isOverrideEnabled: _isOverrideEnabled(),
          libraryPolicy: _getLibraryPolicy(),
          orgLibraries: _getOrgLibraries(),
          orgLicenses: _getOrgLicenses()
        })
        .catch(ErrorService.processError)
    }

    function _isOverrideEnabled() {
      return preferencesService.getBooleanValue(
        PREFERENCE_PROPERTIES.LIBRARY_POLICY_OVERRIDE
      )
    }

    function _getLibraryPolicy() {
      return LibraryFactory.getLibraryPolicy().then(function (response) {
        return response.data
      })
    }

    function _getOrgLibraries() {
      return LibraryFactory.getLibrariesPolicy().then(function (response) {
        return response.data.restricted_libraries
      })
    }

    function _getOrgLicenses() {
      return LibraryFactory.getLibraryPolicyLicenses().then(function (
        response
      ) {
        return response.data
      })
    }

    function update(data) {
      return LibraryFactory.updateLibraryPolicy(data)
        .then(function (response) {
          var data = response.data
          logger.logSuccess(data.messages[0])
          return data
        })
        .catch(ErrorService.processError)
    }
  }
})()
